import { createSuggestionsActions, removeSpecialChars } from 'client/common/suggestionsActions'

export const GET_IN_PAGE_SUGGESTIONS_SUCCESS = 'GET_IN_PAGE_SUGGESTIONS_SUCCESS'
export { removeSpecialChars }

export const { onSuggestionsChange } = createSuggestionsActions(GET_IN_PAGE_SUGGESTIONS_SUCCESS)
